import { Navigate } from "react-router-dom";
import Auth from "@services/Auth/Auth";

const ProtectedRoute = ({ children, reqRole }) => {
  const user = Auth.getCurrentUser();
  if (!user) return <Navigate to="/masuk" replace={true} />;
  var isAllowed =
    reqRole.filter((role) => {
      return role === user.role;
    }).length > 0;
  if (!isAllowed) {
    return <Navigate to="/" />;
  }
  return children;
};

export default ProtectedRoute;
